import { Draft, produce } from 'immer';

import { AuthorityResource } from '@app/features/subscription/types/AuthorityResource';
import {
  USER_AUTHORITY__FETCH_SUCCESS,
  USER_AUTHORITY__INITIALIZE,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { UserAuthorityAction } from '@app/store/user/authority/actions';

export type UserAuthorityPermissionsState = {
  [K in AuthorityResource]: {
    id: string | null;
    resource: K;
  };
};

export const initialState: UserAuthorityPermissionsState = {
  ADDRESS_BOOK: {
    id: null,
    resource: 'ADDRESS_BOOK',
  },
  API: {
    id: null,
    resource: 'API',
  },
  APPROVAL: {
    id: null,
    resource: 'APPROVAL',
  },
  BULK_REQUEST: {
    id: null,
    resource: 'BULK_REQUEST',
  },
  CUSTOM_BRANDING_EMAIL: {
    id: null,
    resource: 'CUSTOM_BRANDING_EMAIL',
  },
  CUSTOM_BRANDING_KAKAO_CHANNEL: {
    id: null,
    resource: 'CUSTOM_BRANDING_KAKAO_CHANNEL',
  },
  DOCUMENT: {
    id: null,
    resource: 'DOCUMENT',
  },
  DOCUMENT_REMINDER: {
    id: null,
    resource: 'DOCUMENT_REMINDER',
  },
  EDITING_DOCUMENT: {
    id: null,
    resource: 'EDITING_DOCUMENT',
  },
  EXPORT_INPUT_VALUES: {
    id: null,
    resource: 'EXPORT_INPUT_VALUES',
  },
  EXTERNAL_DOCUMENT: {
    id: null,
    resource: 'EXTERNAL_DOCUMENT',
  },
  CONTRACT_LINK: {
    id: null,
    resource: 'CONTRACT_LINK',
  },
  TEMPLATE: {
    id: null,
    resource: 'TEMPLATE',
  },
  WEBHOOK: {
    id: null,
    resource: 'WEBHOOK',
  },
  IN_PERSON_CONTRACT: {
    id: null,
    resource: 'IN_PERSON_CONTRACT',
  },
  SCHEDULED_REQUEST: {
    id: null,
    resource: 'SCHEDULED_REQUEST',
  },
};

const reducer = produce(
  (draft: Draft<UserAuthorityPermissionsState>, action: UserAuthorityAction) => {
    switch (action.type) {
      case USER_AUTHORITY__FETCH_SUCCESS:
      case USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS: {
        (Object.keys(AuthorityResource) as AuthorityResource[]).forEach((key) => {
          draft[key].id = null;
        });
        if (action.payload) {
          const { permissions } = action.payload;
          permissions.forEach((permission) => {
            if (draft[permission.resource]) {
              draft[permission.resource].id = permission.id;
              draft[permission.resource].resource = permission.resource;
            }
          });
        }
        return draft;
      }
      case USER_AUTHORITY__INITIALIZE:
        return initialState;
      default:
        return draft;
    }
  },
  initialState
);

export default reducer;
